(function () {
  var image = $(".jarallax-img");
  if (!image) return;

  var options = {
    disableParallax: /iPad|iPhone|iPod|Android/,
    disableVideo: /iPad|iPhone|iPod|Android/,
    speed: 0.1,
  };

  image.imagesLoaded(function () {
    image.parent().jarallax(options).addClass("initialized");
  });
})();

(function () {
  "use strict";
  $(".featured-posts").owlCarousel({
    dots: false,
    margin: 30,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
    ],
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
      },
      768: {
        items: 3,
        slideBy: 3,
      },
      992: {
        items: 4,
        slideBy: 4,
      },
    },
  });
})();

$(function () {
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 100) {
      $(".gh-head li a").addClass("active");
    } else {
      $(".gh-head li a").removeClass("active");
    }
  });

  $(function () {
    $(".gh-head li a").on("click", function () {
      $("html,body").animate(
        {
          screenTop: $($.attr(this, "href")).offset().top,
        },
        1500
      );
    });
  });
});

//for all links
// var links = document.querySelectorAll('a');
// links.forEach((link) => {
//     var a = new RegExp('/' + window.location.host + '/');
//     if(!a.test(link.href)) {
//       	link.addEventListener('click', (event) => {
//             event.preventDefault();
//             event.stopPropagation();
//             window.open(link.href, '_blank');
//         });
//     }
// });

$(function () {
  $(".gh-powered-by .gh-foot-icon .nav a")
    .filter(function () {
      return this.hostname && this.hostname !== location.hostname;
    })
    .attr("target", "_blank");
});

$(function () {
  $(".kg-card.kg-button-card .kg-btn")
    .filter(function () {
      return this.hostname && this.hostname !== location.hostname;
    })
    .attr("target", "_blank");
});

$(window).scroll(function () {
  var scrollTop = $(window).scrollTop();
  var logo2 = $(".gh-head-logo img:nth-child(2)");
  var head = $(".gh-head");

  if (scrollTop > 0) {
    logo2.css("opacity", "0");
    head.css("height", "80px");
  } else {
    logo2.css("opacity", "1");
    head.css("height", "100px");
  }
});
